import type { AgentOutputProps } from '../types'

/** Fallback renderer — pretty-prints the result JSON in a scrollable pre. */
export default function JsonRenderer({ result }: AgentOutputProps) {
  let pretty = ''
  try {
    pretty = typeof result === 'string' ? result : JSON.stringify(result, null, 2)
  } catch {
    pretty = String(result)
  }
  return (
    <pre className="text-xs bg-muted/40 border border-border rounded p-3 overflow-auto max-h-[520px]">
      {pretty}
    </pre>
  )
}
